<template>
    <el-tabs v-model="searchType" type="border-card" class="card-tab" @tab-click="handleClick" lazy id="Tomd">
      <!-- {{ fileList }} -->
      <el-tab-pane label="查认证状态" name="1" style="height: 500px;">
        <el-row>选择导入的字段</el-row>
        <el-row>
          <el-radio v-model="indexType" label="1">身份证号</el-radio>
          <el-radio v-model="indexType" label="2">促销员ID</el-radio>
          <el-radio v-model="indexType" label="3">手机号</el-radio>
        </el-row>
        <el-row>
          <el-col :span="2">字段所在列：</el-col>
          <el-col :span="1">
            <el-input-number :value="indexCol" :min="1" size="medium" step-strictly ref="indexCol" :controls="false"
              @input.native="indexColChange" @change.native="indexColChange"></el-input-number>
          </el-col>
          <el-col :span="4" style="color:red;margin-left: 60px;">导入的字段在文件中的第几列</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">结果所在列：</el-col>
          <el-col :span="1">
            <el-input-number :value="valCol" :min="1" size="medium" step-strictly ref="valCol" :controls="false"
              @input.native="valColChange" @change.native="valColChange"></el-input-number>
          </el-col>
          <el-col :span="5"><span style="color:red;margin-left: 60px;">查询的结果存在附件的第几列</span></el-col>
        </el-row>
        <el-row style="width: 250px;">
          <el-upload class="upload-demo" ref="upload1" :action="action" :before-remove="beforeRemove" :limit="1"
            :auto-upload="false" :on-exceed="handleExceed" accept=".xls, .xlsx" :before-upload="beforeUpload"
            :file-list="fileList" :on-success="uploadSuccess" :on-change="handleChange" :on-remove="handleRemove"
            :on-error="handleError" :disabled="btnAbled">
            <el-button slot="trigger" size="small" type="primary" :disabled="btnAbled">点击上传</el-button>
            <el-button style="margin-left: 10px; border: none;" size="small" type="primary" @click="submitUpload('upload1')"
              :disabled="showbtn || (fileList&&fileList.length===0)" v-loading="loading">导出结果</el-button>
          </el-upload>
        </el-row>
        <el-row style="color: red;">
          TIPS：<br />
          仅支持excel文件导入，且大小不超过25M<br />
          导入文件的第一行视为表头，不做处理<br />
          导入的文件请不要有空行/列，不要有隐藏行/列<br />
        </el-row>
      </el-tab-pane>
  
  
      <el-tab-pane label="查促销员ID" name="2" style="height: 500px;">
        <el-row>选择导入的字段</el-row>
        <el-row>
          <el-radio v-model="indexType" label="1">身份证号</el-radio>
          <el-radio v-model="indexType" label="3">手机号</el-radio>
        </el-row>
        <el-row>
          <el-col :span="2">字段所在列：</el-col>
          <el-col :span="1">
            <el-input-number :value="indexCol" :min="1" size="medium" step-strictly ref="indexCol" :controls="false"
              @input.native="indexColChange" @change.native="indexColChange"></el-input-number>
          </el-col>
          <el-col :span="4" style="color:red;margin-left: 60px;">导入的字段在文件中的第几列</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">结果所在列：</el-col>
          <el-col :span="1">
            <el-input-number v-model="valCol" :min="1" size="medium" step-strictly ref="valCol" :controls="false"
              @click.native="valColChange" @input.native="valColChange" @change.native="valColChange"></el-input-number>
          </el-col>
          <el-col :span="5"><span style="color:red;margin-left: 60px;">查询的结果存在附件的第几列</span></el-col>
        </el-row>
        <el-row style="width: 250px;">
          <el-upload class="upload-demo" ref="upload" :action="action" :before-remove="beforeRemove" :limit="1"
            :auto-upload="false" :on-exceed="handleExceed" accept=".xls, .xlsx" :before-upload="beforeUpload"
            :file-list="fileList" :on-success="uploadSuccess" :on-change="handleChange" :on-remove="handleRemove"
            :on-error="handleError" :disabled="btnAbled">
            <el-button slot="trigger" size="small" type="primary" :disabled="btnAbled">点击上传</el-button>
            <el-button style="margin-left: 10px; border: none;" size="small" type="primary" @click="submitUpload('upload')"
              :disabled="showbtn || (fileList&&fileList.length===0)" v-loading="loading">导出结果</el-button>
          </el-upload>
        </el-row>
        <el-row style="color: red;">
          TIPS：<br />
          仅支持excel文件导入，且大小不超过25M<br />
          导入文件的第一行视为表头，不做处理<br />
          导入的文件请不要有空行/列，不要有隐藏行/列<br />
        </el-row>
      </el-tab-pane>
  
  
      <el-tab-pane label="查灵工签约状态" name="3" style="height: 500px;">
        <el-row>选择导入的字段</el-row>
        <el-row>
          <el-radio v-model="indexType" label="1">身份证号</el-radio>
          <el-radio v-model="indexType" label="2">促销员ID</el-radio>
          <el-radio v-model="indexType" label="3">手机号</el-radio>
        </el-row>
        <el-row>
          <el-col :span="2">签约项目：</el-col>
          <el-col :span="3">
            <el-select v-model="contract" filterable placeholder="请选择" @change="changeValue()">
              <el-option v-for="item in options" :key="item.id" :label="item.projectName" :value="item.projectCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">字段所在列：</el-col>
          <el-col :span="1">
            <el-input-number :value="indexCol" :min="1" size="medium" step-strictly ref="indexCol" :controls="false"
              @input.native="indexColChange" @change.native="indexColChange"></el-input-number>
          </el-col>
          <el-col :span="4" style="color:red;margin-left: 60px;">导入的字段在文件中的第几列</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">结果所在列：</el-col>
          <el-col :span="1">
            <el-input-number v-model="valCol" :min="1" size="medium" step-strictly ref="valCol" :controls="false"
              @click.native="valColChange" @input.native="valColChange" @change.native="valColChange"></el-input-number>
          </el-col>
          <el-col :span="5"><span style="color:red;margin-left: 60px;">查询的结果存在附件的第几列</span></el-col>
        </el-row>
        <el-row style="width: 250px;">
          <el-upload class="upload-demo" ref="upload2" :action="action" :before-remove="beforeRemove" :limit="1"
            :auto-upload="false" :on-exceed="handleExceed" accept=".xls, .xlsx" :before-upload="beforeUpload"
            :file-list="fileList" :on-success="uploadSuccess" :on-change="handleChange" :on-remove="handleRemove"
            :on-error="handleError" :disabled="btnAbled">
            <el-button slot="trigger" size="small" type="primary" :disabled="btnAbled">点击上传</el-button>
            <el-button style="margin-left: 10px; border: none;" size="small" type="primary" @click="submitUpload('upload2')"
              :disabled="showbtn || (fileList&&fileList.length===0)" v-loading="loading">导出结果</el-button>
          </el-upload>
        </el-row>
        <el-row style="color: red;">
          TIPS：<br />
          仅支持excel文件导入，且大小不超过25M<br />
          导入文件的第一行视为表头，不做处理<br />
          导入的文件请不要有空行/列，不要有隐藏行/列<br />
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </template>
  <script>
  import utils from "../../../common/js/util.js";
  export default {
    data() {
      return {
        action: '',
        searchType: '1',
        indexType: '1',
        indexCol: undefined,
        valCol: undefined,
        fileList: [],
        showbtn: true,
        btnAbled: true,
        options: [],
        contract: '',
        loading: false
      };
    },
    mounted(){
      window.$this = this;
    },
    methods: {
      //标签页切换
      handleClick(tab, event) {
        this.indexType = '1';
        this.indexCol = undefined;
        this.valCol = undefined;
        this.showbtn = true;
        this.fileList = [];
        this.btnAbled = true;
        this.contract = '';
        // this.$refs.upload.clearFiles();
        if ('3' == this.searchType) {
          this.constantList();
        }
      },
      constantList() {
        this.$http({
          method: "GET",
          url: "/rest/project/constantList",
        })
          .then((res) => {
            this.options = res.data;
          })
          .catch((err) => {
            this.myNotify(this, "error", err.response, "查询失败，请稍后重试");
          });
      },
      indexColChange(val) {
        this.indexCol = val.target.value || undefined;
        if (/^\d+$/.test(val.target.value)) {
          if ('3' == this.searchType) {
            if ('' != this.contract && /^\d+$/.test(this.valCol)) {
              this.btnAbled = false;
            } else {
              this.btnAbled = true;
            }
          } else {
            if (/^\d+$/.test(this.valCol)) {
              this.btnAbled = false;
            } else {
              this.btnAbled = true;
            }
          }
        } else {
          this.btnAbled = true;
        }
      },
      valColChange(val) {
        this.valCol = val.target.value || undefined;
        if (/^\d+$/.test(val.target.value)) {
          if ('3' == this.searchType) {
            if ('' != this.contract && /^\d+$/.test(this.indexCol)) {
              this.btnAbled = false;
            } else {
              this.btnAbled = true;
            }
          } else {
            if (/^\d+$/.test(this.indexCol)) {
              this.btnAbled = false;
            } else {
              this.btnAbled = true;
            }
          }
        } else {
          this.btnAbled = true;//置灰
        }
      },
      changeValue() {
        if ('' != this.contract && /^\d+$/.test(this.indexCol) && /^\d+$/.test(this.valCol)) {
          this.btnAbled = false;
        } else {
          this.btnAbled = true;
        }
      },
      handleExceed(file, fileList) {
        this.$message.error('只能上传一个文件,请删除后重新上传！');
      },
      handleChange(file, fileList) {
        this.fileList = fileList
        if (fileList && fileList.length) {
          this.showbtn = false;
        }
      },
      handleRemove(file, fileList) {
        this.showbtn = true;
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleError(err) {
        this.$nextTick(()=>{
          this.reset();
        })
        this.$message.error(err);
      },
      beforeUpload(file) {
        const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
        const whiteList = ["xls", "xlsx"];
  
        if (whiteList.indexOf(fileSuffix) === -1) {
          this.$message.error('上传文件只能是 xls、xlsx 格式');
          return false;
        }
  
        const isLt2M = file.size / 1024 / 1024 < 25;
  
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 25MB');
          return false;
        }
      },
      uploadSuccess(res) {
        this.$nextTick(()=>{
          this.reset();
        })
        location.href = utils.returnUrlHead() + res.data;
      },
      reset() {
        this.btnAbled = true;
        this.indexCol = undefined;
        this.showbtn = true;
        this.fileList = [];
        this.valCol = undefined;
        this.contract = '';
        this.loading = false;
      },
      submitUpload(refName) {
        this.action = `/rest/salesman/tomd?indexCol=${this.indexCol}&valCol=${this.valCol}&searchType=${this.searchType}&indexType=${this.indexType}&projectCode=${this.contract}`;
        this.$nextTick(() => {
          this.$refs[refName].submit();
        })
        this.loading = true;
      },
  
  
    }
  };
  </script>
  <style lang="scss" scoped>
  .el-row {
    margin: 10px 0px;
    line-height: 40px;
  }
  
  .el-input-number {
    display: block;
  }
  
  /deep/ .el-input-number.is-without-controls .el-input__inner {
    width: 100px;
    height: 35px;
  }
  
  .upload-demo {
    display: inline;
  }
  
  #Tomd{
    /deep/ .el-button--primary {
    background-color: rgba(47, 44, 120, 1);
    border: none;
    }
    
    /deep/ .el-button--primary:hover {
    background-color: rgba(47, 44, 120, 1);
    border: none;
    }
  }
// /deep/ .el-button--primary.is-disabled {
//     background-color: rgba(174, 174, 174, 1);
//     border: none;
// }

// /deep/ .el-button--success {
//     background-color: rgba(47, 44, 120, 1);
// }

// /deep/ .el-button--success.is-disabled {
//     background-color: rgba(174, 174, 174, 1);
// }
  
  .el-tabs {
    background-color: #fff;
  }
  
  /deep/ .el-tabs__content {
    padding-left: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/configCanage/tomd/Tomd.vue